module.exports = __webpack_public_path__ + "images/eyes.c40846e0dd7c828f8846.png";